import { z } from "zod/v4";

import { castToNumber } from "../utils";

export const StripeMeterAppUsageRecordDtoSchema = z.object({
  createdAtTs: z.number(),
  description: z.string(),
  price: castToNumber,
});

export type OrganizationMeterAppUsageRecordDto = z.infer<
  typeof StripeMeterAppUsageRecordDtoSchema
>;

export const OrganizationMeterLogDtoSchema = z.object({
  id: z.uuid(),
  stripeCustomerId: z.string(),
  periodStart: z.number(),
  periodEnd: z.number(),
  stripeSubscriptionLinkId: z.uuid(),
  stripeProductLinkId: z.uuid().nullish(),
  organizationId: z.uuid(),
  meteredBillingMethod: z.string(),
  meteredBillingAmount: z.number(),
  createdAtTs: z.number(),
});

export type OrganizationMeterLogDto = z.infer<
  typeof OrganizationMeterLogDtoSchema
>;

export const StripeMeterLogByPeriodDtoSchema = z.object({
  periodStart: z.number(),
  periodEnd: z.number(),
  events: OrganizationMeterLogDtoSchema.array(),
});

export type OrganizationMeterLogByPeriodDto = z.infer<
  typeof StripeMeterLogByPeriodDtoSchema
>;

export const CreateOrganizationMeterLogDtoSchema =
  OrganizationMeterLogDtoSchema.extend({
    id: z.uuid().nullish(),
  });

export type CreateOrganizationMeterLogDto = z.infer<
  typeof CreateOrganizationMeterLogDtoSchema
>;
